// import axios from '../../axios-auth'

const state = {
  MDI_coaching_levels: [
    'CTP Only', 'CTP & E-Coaching', 'Personal/Group Coaching (Bronze)', 'Personal/Group Coaching (Silver)', 'Personal/Group Coaching (Gold)',
  ],
  MDI_summerfall_categories: [
    'Mount Pleasant', 'High Park', 'West Toronto', 'Lawrence Park', 'Oakville/Missy',
    // "CTP &/OR E-Coaching", "Premium Coaching", "MDI Coach", "Dynamo Mastery Team"
  ],
  MDI_winterspring_categories: [
    'Mississauga Stadium', 'High Park', 'Monarch Park AM', 'Monarch Park PM',
    // "CTP &/OR E-Coaching", "Premium Coaching", "MDI Coach", "Dynamo Mastery Team"
  ],
  payment_statuses: [
    'No Payment', 'CTP Paid', 'CTP & Coaching Paid',
  ],
  workouts: [
    'OMP Flat', 'OMP Hilly', 'Intensity', 'Intensity (Tempo)',
    'Intensity (Cruise-Tempo)', 'Race Pace', 'LSD', 'Progression Start',
    'Progression Finish', 'Fartlek', 'X-Training', 'Easy Run',
  ],
};

const mutations = {

};

const actions = {

};

const getters = {
  MDIcoachingLevels (state) {
    return state.MDI_coaching_levels
  },
  MDIsummerfallCategories (state) {
    return state.MDI_summerfall_categories
  },
  MDIwinterspringCategories (state) {
    return state.MDI_winterspring_categories
  },
  paymentStatuses (state) {
    return state.payment_statuses
  },
  MDIworkouts (state) {
    return state.workouts
  }
};

export default {
  state,
  mutations,
  actions,
  getters,
}



// WEBPACK FOOTER //
// ./src/store/teams/MDI.js